// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FeatureMessages_wrapper__xgw_8","description":"FeatureMessages_description__6nu3o"};